/* src/app/components/payroll/invoices/consumer/invoice-consumer-list/invoice-consumer-list.component.css */
.line1 {
  display: flex;
  justify-content: space-between;
}
.filters {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.ant-select-selector {
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
.check-filter {
  width: 100%;
  height: 32px;
  padding: 0 11px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.85);
}
:host ::ng-deep .accordion-body {
  gap: 12px !important;
}
.message {
  margin-bottom: 0px;
  margin-top: 16px;
  margin-left: 8px;
  font-weight: 500;
}
:host ::ng-deep .in-process th {
  width: 11% !important;
}
:host ::ng-deep td.service-dates-cell,
:host ::ng-deep td.service-dates-cell .truncate-text {
  white-space: pre-line;
  overflow: visible;
  text-overflow: clip;
}
.ant-form-item {
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}
.invoice-action-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
@media (max-width: 768px) {
  .filters {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }
  .invoice-action-buttons {
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;
    margin-top: 4px;
  }
  .invoice-action-buttons ppl-button {
    flex: 1 1 auto;
    min-width: 0;
  }
}
@media (max-width: 430px) {
  .invoice-action-buttons {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: stretch;
  }
  .invoice-action-buttons ppl-button:first-child {
    min-width: 0;
  }
}
/*# sourceMappingURL=invoice-consumer-list.component-MB75VLMN.css.map */
